import React, { useEffect, useRef, useState } from "react";
import ApexCharts from "apexcharts";
import Chart from "react-apexcharts";
import { Bar } from "react-chartjs-2";
import { useNavigate } from "react-router-dom";
import DashboardLayout from "../../DashboardLayout";
import { handleErrors } from "../../../services/dataManager";
import { Form, Tab, Table, Tabs } from "react-bootstrap";
import {
  fetchadsCountByGames,
  fetchadsCountByGames12Months,
} from "../../../services/axios/apiManager";
import {
  Chart as ChartJS,
  BarElement,
  CategoryScale,
  LinearScale,
  Tooltip,
  Legend,
} from "chart.js";
import { getFormattedAdAnalytics, getMonths } from "../helperMethods";
import $ from "jquery";
import "datatables.net-bs5";
import "datatables.net-bs5/css/dataTables.bootstrap5.min.css";

ChartJS.register(BarElement, CategoryScale, LinearScale, Tooltip, Legend);

function AdViewCount() {
  const tableRef = useRef(null);
  const navigate = useNavigate();
  const [range, setRange] = useState("daily");
  const [userType, setUserType] = useState("");
  const [yearlyData, setYearlyData] = useState([]);
  const [tableData, setTableData] = useState([]);

  const onChangeRange = async (rng) => {
    setRange(rng.toLowerCase());
    await getadsCountByGames(rng.toLowerCase(), userType);
  };
  const getadsCountByGames = async (timeRange = range, type = userType) => {
    const res = await fetchadsCountByGames(timeRange, type);
    if (res?.data?.success && res?.data?.data) {
      setTableData(res.data.data);
    } else {
      handleErrors(res, navigate);
    }
  };
  const getadsCountByGames12Months = async () => {
    const res = await fetchadsCountByGames12Months();
    if (res?.data?.success && res?.data?.data) {
      const results = await getFormattedAdAnalytics(res.data.data);
      setYearlyData(results);
    } else {
      handleErrors(res, navigate);
    }
  };

  const handleFilterChange = async (e) => {
    setUserType(e.target.value);
    await getadsCountByGames(range, e.target.value);
  };

  const handleReset = async () => {
    setUserType("");
    await getadsCountByGames(range, "");
  };

  const generateChartData = () => {
    const labels = tableData.map((m) => m?.game_title);
    const guestData = tableData.map((m) => parseInt(m?.guest));
    const registeredData = tableData.map((m) => parseInt(m?.registered));
    const dataset = {
      labels: labels,
      datasets: [
        {
          label: "Guest",
          data: guestData,
        },
        {
          label: "Registered",
          data: registeredData,
        },
      ],
    };
    return dataset;
  };

  const chartOptions = {
    responsive: true,
    maintainAspectRatio: true,
    plugins: {
      legend: {
        labels: { color: "#ffffff" },
      },
      tooltip: { enabled: true },
    },
    scales: {
      x: { ticks: { color: "#ffffff" } },
      y: { ticks: { color: "#ffffff" } },
    },
  };
  useEffect(() => {
    getadsCountByGames();
    getadsCountByGames12Months();
  }, []);

  useEffect(() => {
    const $table = $(tableRef.current);
    const rows = tableData.map((item) => {
      return [
        item.game_title,
        item.total_ads,
        item.skiped_ads,
        item.watched_ads,
        item.registered,
        item.guest,
      ];
    });

    const config = {
      data: rows,
      columns: [
        { title: "Game Name" },
        { title: "Ad Views" },
        { title: "Skipped" },
        { title: "Viewed" },
        { title: "Registered" },
        { title: "Guest" },
      ],
      destroy: true,
      responsive: true,
      paging: false,
      searching: false,
    };

    if ($.fn.dataTable.isDataTable(tableRef.current)) {
      $table.DataTable().clear().rows.add(rows).draw();
    } else {
      $table.DataTable(config);
    }
    return () => {
      if ($.fn.dataTable.isDataTable(tableRef.current)) {
        $table.DataTable().destroy();
      }
    };
  }, [tableData]);

  useEffect(() => {
    if (yearlyData?.length) {
      let months = getMonths();
      const seriesData = yearlyData.map((game) => ({
        name: game.title,
        data: game.data.map((month) => ({
          x: month.date,
          y: month.total_ads,
        })),
      }));
      window.Apex = {
        chart: {
          foreColor: "#ccc",
          toolbar: { show: false },
          animations: { enabled: true },
        },
        stroke: { width: 3 },
        dataLabels: { enabled: false },
        tooltip: { theme: "dark" },
        grid: {
          borderColor: "#535A6C",
          xaxis: { lines: { show: true } },
        },
      };

      var optionsArea = {
        chart: {
          height: 380,
          type: "area",
          stacked: false,
        },
        stroke: {
          curve: "straight",
        },
        series: seriesData,
        xaxis: {
          categories: months,
        },

        tooltip: {
          followCursor: true,
        },
        fill: {
          opacity: 1,
        },
      };

      var chartArea = new ApexCharts(
        document.querySelector("#areachart"),
        optionsArea
      );
      chartArea.render();
    }
  }, [yearlyData]);

  return (
    <DashboardLayout>
      <>
        {/* Filter + Tabs Card */}
        <div className="card bg-dark text-white mt-3">
          <div className="card-body">
            <h5 className="card-title">Filter by User Type</h5>
            <div className="row align-items-center mb-4">
              <div className="col-md-3">
                <Form.Select
                  className="bg-dark text-light border-light"
                  value={userType}
                  onChange={handleFilterChange}
                >
                  <option value="">All user types</option>
                  <option value="guest">Guest</option>
                  <option value="registered">Registered</option>
                </Form.Select>
              </div>
              <div className="col-md-2">
                <button
                  className="btn btn-success"
                  style={{ display: userType === "" ? "none" : "block" }}
                  onClick={handleReset}
                >
                  Reset
                </button>
              </div>
            </div>

            <Tabs
              activeKey={range}
              onSelect={(k) => onChangeRange(k)}
              className="mb-0"
              variant="pills"
            >
              {["Daily", "Weekly", "Monthly"].map((period) => (
                <Tab
                  eventKey={period.toLowerCase()}
                  title={period}
                  key={period}
                ></Tab>
              ))}
            </Tabs>
          </div>
        </div>

        <div className="mt-3">
          <div className="card bg-dark text-white mb-3">
            <div className="card-body">
              <h5 className="card-title">Ad View Count</h5>
              <p className="card-text">
                Analyzing this data can help you identify Total ad views per
                game.
              </p>
              <div className="table-responsive">
                <table
                  ref={tableRef}
                  className="table table-dark table-striped table-hover w-100"
                />
                {tableData?.length === 0 && (
                  <p className="mt-3 text-center">No data available.</p>
                )}
              </div>
            </div>
          </div>

          <div className="card bg-dark text-white mb-3">
            <div className="card-body">
              <div className="mb-4">
                {tableData?.length ? (
                  <Bar data={generateChartData()} options={chartOptions} />
                ) : (
                  <p className="mt-3 text-center">No data available.</p>
                )}
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-12 col-md-6">
              <div className="card bg-dark text-white mt-3">
                <div className="card-body">
                  <h5 className="card-title mb-4">
                    Ad View Completion (%) Per Game
                  </h5>
                  {tableData?.length ? (
                    <Chart
                      options={{
                        chart: {
                          type: "bar",
                          toolbar: { show: false },
                        },
                        plotOptions: {
                          bar: {
                            horizontal: true,
                            barHeight: "60%",
                            borderRadius: 6,
                          },
                        },
                        dataLabels: {
                          enabled: true,
                          formatter: function (val) {
                            return val + "%";
                          },
                          style: {
                            colors: ["#fff"],
                          },
                        },
                        xaxis: {
                          categories: tableData.map((item) => item.game_title),
                          labels: {
                            style: { colors: "#fff" },
                          },
                        },
                        yaxis: {
                          labels: {
                            style: { colors: "#fff" },
                          },
                        },
                        tooltip: {
                          theme: "dark",
                        },
                        colors: ["#00e396"],
                      }}
                      series={[
                        {
                          name: "% Viewed",
                          data: tableData?.map((item) =>
                            item.total_ads > 0 && item.watched_ads > 0
                              ? (
                                  (item.watched_ads / item.total_ads) *
                                  100
                                ).toFixed(1)
                              : 0
                          ),
                        },
                      ]}
                      type="bar"
                      height={400}
                    />
                  ) : (
                    <p className="mt-3 text-center">No data available.</p>
                  )}
                </div>
              </div>
            </div>
            <div className="col-12 col-md-6">
              <div className="card bg-dark text-white mt-3">
                <div className="card-body">
                  <h5 className="card-title mb-3">Ads Viewed Per Game</h5>
                  <div id="areachart"></div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </>
    </DashboardLayout>
  );
}

export default AdViewCount;
